import React, { useState } from 'react';
import DatePicker from "react-datepicker";
import { Field } from 'react-final-form';
import { isAfter, isValid } from 'date-fns';

import { FormFeedback } from './index';

import 'react-datepicker/dist/react-datepicker.css';
import './FormDateInput.css';

const renderDateInput = ({ input, meta, inputOnChange, dateFormat, screenDimensions }) => {
  const dateInputProps = {
    ...input,
    // make sure input.value is a date object
    value: new Date(input.value),
    onChange: e => {
      input.onChange(e);
      inputOnChange && inputOnChange(e);
    }
  }
  
  return (
    <React.Fragment>
      <DatePicker
        {...dateInputProps}
        className="form-input__control date-input"
        selected={isValid(new Date(dateInputProps.value)) ? new Date(dateInputProps.value) : ''}
        dateFormat={dateFormat}
        withPortal={screenDimensions.width <= 1023 ? true : false}
        dayClassName={date => (dateInputProps.name !== 'dueDate' && isAfter(date, new Date()) ? 'date-input__disabled' : undefined)}
      />

      {meta.error && meta.dirty && (
        <FormFeedback positive={false}>
          {meta.error}
        </FormFeedback>
      )}
    </React.Fragment>
  )
}

export default props => {
  const {
    name,
    initialValue,
    validate,
    labelRenderer,
    dateFormat
  } = props;

  const [date, setDate] = useState(new Date(initialValue) || new Date());
  const screenDimensions = {
    width: window.innerWidth,
    height: window.innerHeight
  };

  
  const handleChange = e => {
    if (e && e.date) {
      setDate(e.date);
    }
  }
  
  return (
    <div>
      <label
        className="form-input"
      >
        {typeof labelRenderer === 'function' && labelRenderer()}
      </label>
      <Field 
        name={name}
        initialValue={date}
        dateFormat={dateFormat}
        component={renderDateInput}
        screenDimensions={screenDimensions}
        inputOnChange={handleChange}
        validate={validate}
      />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/form/FormDateInput.js